import '@babel/polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(advancedFormat);

window.Vue = Vue;
window.Vuex = Vuex;
window.VueRouter = VueRouter;

Object.defineProperty(Vue.prototype, '$dayjs', { value: dayjs });
